import {
  AccountBalanceWallet,
  Assignment,
  AttachMoney,
  Cancel,
  Dashboard,
  FileUpload,
  Forum,
  HistoryOutlined,
  HowToReg,
  People,
  Report,
  Verified,
} from "@mui/icons-material";
import PublishedWithChangesOutlinedIcon from "@mui/icons-material/PublishedWithChangesOutlined";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import AutoModeOutlinedIcon from "@mui/icons-material/AutoModeOutlined";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import { MdSupportAgent } from "react-icons/md";

import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import VerifiedIcon from "@mui/icons-material/Verified";
import BlockOutlined from "@mui/icons-material/BlockOutlined";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import UpdateIcon from "@mui/icons-material/Update";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PolicyIcon from "@mui/icons-material/Policy";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";


export const navigation = [
  {
    name: "Dashboard",
    path: "dashboard",
    permission: "view-dashboard",
    icon: Dashboard,
    menu: [
      {
        name: "Dashboard",
        path: "dashboard",
        icon: "Dashboard",
      },
    ],
  },
  {
    name: "Beneficiary",
    path: "beneficiary",
    permission: "view-beneficiary",
    icon: People,
    menu: [
      {
        name: "Beneficiary",
        path: "beneficiary",
        icon: "People",
      },
    ],
    sidebarNavigations: [
      {
        name: "Beneficiary",
        path: "beneficiary/form",
        permission: "create-beneficiary",
        titleKey: "Create Beneficiary",
      },
    ],
  },
  {
    name: "Eligibility",
    path: "eligibility",
    permission: "view-eligibility",
    icon: HowToReg,
    menu: [
      {
        name: "Eligibility",
        path: "eligibility",
        icon: "HowToReg",
      },
    ],
  },
  // {
  //   name: "Providers",
  //   path: "providers",
  //   permission: "view-providers",
  // },
  {
    name: "Pre-Auth",
    path: "preauth",
    permission: "view-preauth",
    icon: Verified,
    menu: [
      {
        name: "Pre-Auth Work Bench",
        path: "preauth",
        icon: "VerifiedIcon",
      },
      {
        name: "Advance Preauth",
        path: "preauth/advance/preauth",
        icon: "FactCheckIcon",
      },
      {
        name: "Preauth Manager",
        path: "preauth/manager",
        icon: "ManageAccountsIcon",
      },
      // {
      //   name: "Approval Status Monitor",
      //   path: "approval-status-monitor",
      //   icon: "VerifiedIcon",
      // },
      {
        name: "AI Approval Agent",
        path: "preauth/ai-agent",
        icon: "AutoModeOutlinedIcon",
      },
    ],
    sidebarNavigations: [
      {
        name: "Pre-Auth",
        path: "preauth/form",
        permission: "view-preauth",
        titleKey: "Request Preauthorization",
      },
    ],
  },
  {
    name: "Claims",
    path: "claims",
    permission: "view-claims",
    icon: Assignment,
    menu: [
      {
        name: "Transaction",
        path: "claims",
        icon: "FormatListBulletedOutlinedIcon",
      },
      {
        name: "Claims Processing",
        path: "claims/processing",
        icon: "AssignmentTurnedInIcon",
      },
      {
        name: "AI Agents",
        path: "claims/ai-agent",
        icon: "AutoModeOutlinedIcon",
      },
      {
        name: "Ready for Submissions",
        path: "claims/submit",
        icon: "PublishedWithChangesOutlinedIcon",
      },
      {
        name: "Bulk Submissions",
        path: "claims/submit-stats",
        icon: "AutoModeOutlinedIcon",
      },
      {
        name: "Bulk Operations",
        path: "claims/bulk-replace",
        icon: "PublishedWithChangesOutlinedIcon",
      },
      {
        name: "Excel Uploads",
        path: "claims/uploads",
        icon: "FileUpload",
      },
      // {
      //   name: 'History',
      //   path: 'claims/history',
      //   icon: 'HistoryOutlined'
      // },
      // {
      //   name: 'GSS Report',
      //   path: 'claims/gss-report',
      //   icon: 'Report'
      // },
      // {
      //   name: 'Claim Report',
      //   path: 'claims/claim-report',
      //   icon: 'ReportGmailerrorredIcon'
      // },
      {
        name: "Denials Management",
        path: "claims/denial/management",
        icon: "BlockOutlined",
      },
    ],
    sidebarNavigations: [
      {
        name: "Claims",
        path: "claims/form",
        permission: "view-claims",
        titleKey: "Request Claim",
      },
    ],
  },
  {
    name: "Communication",
    path: "communications",
    permission: "view-communications",
    icon: Forum,
    menu: [
      {
        name: "Communication",
        path: "communications",
        icon: "Forum",
      },
    ],
  },
  {
    name: "Operations",
    path: "cancellation",
    permission: "view-cancellation",
    icon: Cancel,
    menu: [
      {
        name: "Cancellation",
        path: "cancellation",
        icon: "Cancel",
      },
      {
        name: "Integration Logs",
        path: "integration-logs",
        icon: "InsertDriveFileIcon",
      },
      {
        name: "NHIC",
        path: "nhic/settings",
        icon: "HealthAndSafetyIcon",
      },
      {
        name: "Practitioners",
        path: "physicians",
        icon: "People",
      },
      {
        name: "Price List",
        path: "price-list",
        icon: "AttachMoney",
      },
    ],
  },
  {
    name: "Payments / Reconciliation",
    path: "payments",
    permission: "view-payments",
    icon: AccountBalanceWallet,
    menu: [
      {
        name: "Payments / Reconciliation",
        path: "payments",
        icon: "AccountBalanceWallet",
      },
    ],
  },
  {
    name: "Reports",
    path: "reports-summary",
    permission: "view-physicians",
    icon: InsertDriveFileIcon,
    menu: [
      {
        name: "Reports",
        path: "reports-summary",
        icon: "InsertDriveFileIcon",
      },
    ],
  },
  {
    name: "Help Desk",
    path: "help-desk",
    permission: "view-physicians",
    icon: MdSupportAgent,
    menu: [
      {
        name: "Help Desk",
        path: "help-desk",
        icon: "MdSupportAgent",
      },
    ],
  },

  // {
  //   name: "PriceList",
  //   path: "price-list",
  //   permission: "view-priceList",
  // },
  // {
  //   name: "Physicians",
  //   path: "physicians",
  //   permission: "view-physicians",
  // },
  // {
  //   name: "Users",
  //   path: "users",
  //   permission: "view-users",
  // },
  // {
  //   name: "Tob",
  //   path: "tob",
  //   permission: "view-tob",
  // },
  // {
  //   name: "Verification",
  //   path: "verification",
  //   permission: "view-verification",
  // },
];

export const superAdminNavigation = [
  {
    name: "Dashboard",
    path: "dashboard",
    permission: "view-dashboard",
    icon: Dashboard,
    menu: [
      {
        name: "Dashboard",
        path: "dashboard",
        icon: "Dashboard",
      },
    ],
  },
  {
    name: "User Management",
    path: "super-admin/user-management",
    permission: "view-user-management",
    icon: ManageAccountsIcon,
    menu: [
      {
        name: "User Management",
        path: "super-admin/user-management",
        icon: "ManageAccountsIcon",
      },
    ],
  },
  {
    name: "Pre Auth Update",
    path: "super-admin/preauth-update",
    permission: "view-preauth-update",
    icon: UpdateIcon,
    menu: [
      {
        name: "Pre Auth Update",
        path: "super-admin/preauth-update",
        icon: "UpdateIcon",
      },
    ],
  },
  {
    name: "SFDA Medicine",
    path: "super-admin/sfda-medicine",
    permission: "view-sfda-medicine",
    icon: MedicalServicesIcon,
    menu: [
      {
        name: "SFDA Medicine",
        path: "super-admin/sfda-medicine",
        icon: "MedicalServicesIcon",
      },
    ],
  },
  {
    name: "Integration Logs",
    path: "integration-logs",
    permission: "view-nhic",
    icon: InsertDriveFileIcon,
    menu: [
      {
        name: "Integration Logs",
        path: "integration-logs",
        icon: "InsertDriveFileIcon",
      },
    ],
  },
  {
    name: "NHIC",
    path: "nhic/settings",
    permission: "view-nhic",
    icon: HealthAndSafetyIcon,
    menu: [
      {
        name: "Settings",
        path: "nhic/settings",
        icon: "HealthAndSafetyIcon",
      },
      {
        name: "Health ID Lookup",
        path: "nhic/lookup",
        icon: "HealthAndSafetyIcon",
      },
    ],
  },
];

export const ConnectNavigations = [
  {
    name: "Dashboard",
    path: "dashboard",
    permission: "view-dashboard",
    icon: Dashboard,
    menu: [
      {
        name: "Dashboard",
        path: "dashboard",
        icon: "Dashboard",
      },
    ],
  },
  {
    name: "Beneficiary",
    path: "beneficiary",
    permission: "view-beneficiary",
    icon: People,
    menu: [
      {
        name: "Beneficiary",
        path: "beneficiary",
        icon: "People",
      },
    ],
    sidebarNavigations: [
      {
        name: "Beneficiary",
        path: "beneficiary/form",
        permission: "create-beneficiary",
        titleKey: "Create Beneficiary",
      },
    ],
  },
  {
    name: "Eligibility",
    path: "eligibility",
    permission: "view-eligibility",
    icon: HowToReg,
    menu: [
      {
        name: "Eligibility",
        path: "eligibility",
        icon: "HowToReg",
      },
    ],
  },
  {
    name: "Pre-Auth",
    path: "preauth",
    permission: "view-preauth",
    icon: Verified,
    menu: [
      {
        name: "Pre-Auth Work Bench",
        path: "preauth",
        icon: "VerifiedIcon",
      },
      {
        name: "Advance Preauth",
        path: "preauth/advance/preauth",
        icon: "FactCheckIcon",
      },
      {
        name: "AI Approval Agent",
        path: "preauth/ai-agent",
        icon: "AutoModeOutlinedIcon",
      },
    ],
    sidebarNavigations: [
      {
        name: "Pre-Auth",
        path: "preauth/form",
        permission: "view-preauth",
        titleKey: "Request Preauthorization",
      },
    ],
  },
  {
    name: "Claims",
    path: "claims",
    permission: "view-claims",
    icon: Assignment,
    menu: [
      {
        name: "Transaction",
        path: "claims",
        icon: "FormatListBulletedOutlinedIcon",
      },
      {
        name: "Ready for Submissions",
        path: "claims/submit",
        icon: "PublishedWithChangesOutlinedIcon",
      },
      {
        name: "AI Agents",
        path: "claims/ai-agent",
        icon: "AutoModeOutlinedIcon",
      },

      {
        name: "Bulk Submissions",
        path: "claims/submit-stats",
        icon: "AutoModeOutlinedIcon",
      },
      {
        name: "Bulk Operations",
        path: "claims/bulk-replace",
        icon: "PublishedWithChangesOutlinedIcon",
      },
      {
        name: "Excel Uploads",
        path: "claims/uploads",
        icon: "FileUpload",
      },
      {
        name: "Denials Management",
        path: "claims/denial/management",
        icon: "BlockOutlined",
      },
    ],
    sidebarNavigations: [
      {
        name: "Claims",
        path: "claims/form",
        permission: "view-claims",
        titleKey: "Request Claim",
      },
    ],
  },
  {
    name: "Communication",
    path: "communications",
    permission: "view-communications",
    icon: Forum,
    menu: [
      {
        name: "Communication",
        path: "communications",
        icon: "Forum",
      },
    ],
  },
  {
    name: "Operations",
    path: "cancellation",
    permission: "view-cancellation",
    icon: Cancel,
    menu: [
      {
        name: "Cancellation",
        path: "cancellation",
        icon: "Cancel",
      },
      {
        name: "Integration Logs",
        path: "integration-logs",
        icon: "InsertDriveFileIcon",
      },
      {
        name: "NHIC",
        path: "nhic/settings",
        icon: "HealthAndSafetyIcon",
      },
      {
        name: "Practitioners",
        path: "physicians",
        icon: "People",
      },
      {
        name: "Price List",
        path: "price-list",
        icon: "AttachMoney",
      },
    ],
  },
  {
    name: "Payments / Reconciliation",
    path: "payments",
    permission: "view-payments",
    icon: AccountBalanceWallet,
    menu: [
      {
        name: "Payments / Reconciliation",
        path: "payments",
        icon: "AccountBalanceWallet",
      },
    ],
  },
  {
    name: "Reports",
    path: "reports-summary",
    permission: "view-physicians",
    icon: InsertDriveFileIcon,
    menu: [
      {
        name: "Reports",
        path: "reports-summary",
        icon: "InsertDriveFileIcon",
      },
    ],
  },
  {
    name: "Help Desk",
    path: "help-desk",
    permission: "view-physicians",
    icon: MdSupportAgent,
    menu: [
      {
        name: "Help Desk",
        path: "help-desk",
        icon: "MdSupportAgent",
      },
      {
        name: "Exceptional Beneficiary",
        path: "help-desk/aramco",
        icon: "MdSupportAgent",
      },
    ],
  },
];
